module.exports = __webpack_public_path__ + "img/sv49.e9b0e395.svg";